import { render, staticRenderFns } from "./NavBarItem.vue?vue&type=template&id=f6c3e584&"
import script from "./NavBarItem.vue?vue&type=script&lang=js&"
export * from "./NavBarItem.vue?vue&type=script&lang=js&"
import style0 from "./NavBarItem.vue?vue&type=style&index=0&id=f6c3e584&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports